<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems" class="breadcrumb mx-8"> </v-breadcrumbs>
    <!-- <v-card style="border-radius: 15px"> -->
    <v-row dense class="d-flex mx-8">
      <v-col cols="10" sm="10" md="10" lg="10">
        <v-card-title class="justify-center"
          >{{ $route.query.genename }} ({{
            geneInfo.length > 0 && geneInfo[0].approved_name
          }})</v-card-title
        >
      </v-col>

      <v-col cols="9" sm="9" md="9" lg="9" v-show="geneInfo.length > 0">
        <v-expansion-panels
          multiple
          focusable
          class="data-table-style"
          v-model="panels"
        >
          <v-expansion-panel id="basic">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">Basic Information</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-iterator
                hide-default-footer
                :items="geneInfo"
                v-for="item in geneInfo"
                :key="item._id"
              >
                <template v-slot:default>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>Gene Name</v-list-item-content>
                      <v-list-item-content>
                        <a
                          :href="`https://ngdc.cncb.ac.cn/genbase/search/index?accession=${item.gene_name}&dataType=Nucleotide&dataSource=`"
                          target="_blank"
                          >{{ item.gene_name }}</a
                        >
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>Ensembl Gene ID</v-list-item-content>
                      <v-list-item-content
                        ><a
                          :href="ensemblLink + item.ensembl_id"
                          target="_blank"
                          >{{ item.ensembl_id }}</a
                        ></v-list-item-content
                      >
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>Approved Name</v-list-item-content>
                      <v-list-item-content>{{
                        item.approved_name
                      }}</v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>Alias Symbols</v-list-item-content>
                      <v-list-item-content>{{
                        item.alias_symbols
                      }}</v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>Locus Type</v-list-item-content>
                      <v-list-item-content>{{
                        item.locus_type
                      }}</v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>Chromosome</v-list-item-content>
                      <v-list-item-content>{{
                        item.chromosome
                      }}</v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-content>Gene Summary</v-list-item-content>
                      <v-list-item-content v-show="item.gene_summary != 'NA'">
                        {{ item.gene_summary }}
                      </v-list-item-content>
                      <v-list-item-content v-show="item.gene_summary == 'NA'"
                        >-</v-list-item-content
                      >
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                  <v-chip
                    class="ma-2"
                    color="info"
                    outlined
                    :href="hgncLink + item.hgnc_id"
                    target="_blank"
                  >
                    HGNC
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="info"
                    outlined
                    :href="ncbiGeneLink + item.ncbi_gene_id"
                    target="_blank"
                  >
                    NCBI Gene
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="info"
                    outlined
                    :href="ensemblLink + item.ensembl_id"
                    target="_blank"
                  >
                    Ensembl
                  </v-chip>
                  <!-- <v-chip class="ma-2"
                          color="info"
                          outlined
                          :href="ucscLink+item.ucsc_id"
                          target="_blank">
                    UCSC
                  </v-chip> -->
                  <v-chip
                    class="ma-2"
                    color="info"
                    outlined
                    :href="refseqLink + item.refseq_id"
                    target="_blank"
                  >
                    RefSeq
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="info"
                    outlined
                    :href="uniprotLink + item.uniprot_id"
                    target="_blank"
                  >
                    UniProt
                  </v-chip>
                  <v-chip
                    class="ma-2"
                    color="info"
                    outlined
                    :href="omimLink + item.omim_id"
                    target="_blank"
                  >
                    OMIM
                  </v-chip>
                </template>
              </v-data-iterator>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="gene-exp">
            <v-expansion-panel-header class="font-weight-bold">
              <span>
                <span class="text-decoration-underline">
                  Expression Distribution of {{ $route.query.genename }} in TCGA
                  Pan-Cancer
                </span>
                <span class="mx-2">
                  <v-dialog v-model="dialog" :retain-focus="false">
                    <template v-slot:activator="{}">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color=""
                            x-small
                            icon
                            @click.stop="dialog = true"
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1"
                          >
                            <v-icon>mdi-help-circle</v-icon>
                          </v-btn>
                        </template>
                        <span
                          >Click here to get the extension of tumor
                          abbreviations.</span
                        >
                      </v-tooltip>
                    </template>
                    <v-card style="left: 25%; width: 50%">
                      <v-card-title
                        class="font-weight-bold grey lighten-2"
                        style="padding: 0px 0px 0px 20px"
                      >
                        TCGA Project ID - Project Name
                        <v-spacer></v-spacer>
                        <v-btn icon large @click="dialog = false">
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-simple-table dense fixed-header height="600px">
                        <template v-slot:default>
                          <thead class="font-weight-bold">
                            <tr>
                              <th class="text-left" style="width: 30%">
                                Project ID
                              </th>
                              <th class="text-left" style="width: 70%">
                                Project Name
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>TCGA-ACC</td>
                              <td>Adrenocortical Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-BLCA</td>
                              <td>Bladder Urothelial Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-BRCA</td>
                              <td>Breast Invasive Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-CESC</td>
                              <td>
                                Cervical Squamous Cell Carcinoma and
                                Endocervical Adenocarcinoma
                              </td>
                            </tr>
                            <tr>
                              <td>TCGA-CHOL</td>
                              <td>Cholangiocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-COAD</td>
                              <td>Colon Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-DLBC</td>
                              <td>
                                Lymphoid Neoplasm Diffuse Large B-cell Lymphoma
                              </td>
                            </tr>
                            <tr>
                              <td>TCGA-ESCA</td>
                              <td>Esophageal Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-GBM</td>
                              <td>Glioblastoma Multiforme</td>
                            </tr>
                            <tr>
                              <td>TCGA-HNSC</td>
                              <td>Head and Neck Squamous Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-KICH</td>
                              <td>Kidney Chromophobe</td>
                            </tr>
                            <tr>
                              <td>TCGA-KIRC</td>
                              <td>Kidney Renal Clear Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-KIRP</td>
                              <td>Kidney Renal Papillary Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LGG</td>
                              <td>Brain Lower Grade Glioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LIHC</td>
                              <td>Liver Hepatocellular Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LUAD</td>
                              <td>Lung Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LUSC</td>
                              <td>Lung Squamous Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-MESO</td>
                              <td>Mesothelioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-OV</td>
                              <td>Ovarian Serous Cystadenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PAAD</td>
                              <td>Pancreatic Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PCPG</td>
                              <td>Pheochromocytoma and Paraganglioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PRAD</td>
                              <td>Prostate Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-READ</td>
                              <td>Rectum Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-SARC</td>
                              <td>Sarcoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-SKCM</td>
                              <td>Skin Cutaneous Melanoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-STAD</td>
                              <td>Stomach Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-TGCT</td>
                              <td>Testicular Germ Cell Tumors</td>
                            </tr>
                            <tr>
                              <td>TCGA-THCA</td>
                              <td>Thyroid Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-THYM</td>
                              <td>Thymoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UCEC</td>
                              <td>Uterine Corpus Endometrial Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UCS</td>
                              <td>Uterine Carcinosarcoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UVM</td>
                              <td>Uveal Melanoma</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-dialog>
                </span>
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-show="isShowExpBoxPlot">
              <gene-pancancer-exp
                :gene-name="geneName"
                ref="gene_exp"
                @isshow="isShowExpPancanBoxplot"
              ></gene-pancancer-exp>
            </v-expansion-panel-content>
            <v-expansion-panel-content class="mt-1" v-show="!isShowExpBoxPlot">
              <span>{{ gene_pancancer_no_data }}</span>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="tx-info" v-show="transcript.length > 0">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">
                Transcript Information of {{ $route.query.genename }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table
                dense
                fixed-header
                :height="computeHeight(transcript)"
              >
                <template v-slot:default>
                  <thead class="">
                    <tr>
                      <th class="text-left">Transcript Symbol</th>
                      <th class="text-left">Transcript ID</th>
                      <th class="text-left">Transcript Type</th>
                      <th class="text-left">Transcript Status</th>
                      <th class="text-left">Transcript Support Level</th>
                      <th class="text-left">Protein ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tx in transcript" :key="tx.transcript_id">
                      <td>{{ tx.transcript_name }}</td>
                      <td>
                        <a
                          :href="ensemblLink + tx.transcript_id"
                          target="_blank"
                          >{{
                            tx.transcript_id && tx.transcript_id.split(".")[0]
                          }}</a
                        >
                      </td>
                      <td>{{ tx.transcript_type }}</td>
                      <td>{{ tx.transcript_status }}</td>
                      <td>{{ tx.transcript_level }}</td>
                      <td>
                        <a
                          :href="ensemblLink + tx.protein_id"
                          target="_blank"
                          >{{ tx.protein_id && tx.protein_id.split(".")[0] }}</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="tx-struct" v-show="transcript.length > 0">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">
                Transcript Structures of {{ $route.query.genename }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <gene-transcript-structure
                :gene-name="geneName"
              ></gene-transcript-structure>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="iso-pct">
            <v-expansion-panel-header class="font-weight-bold">
              <span>
                <span class="text-decoration-underline">
                  Isoform Percentage of {{ $route.query.genename }} in TCGA
                  Pan-Cancer
                </span>
                <span class="mx-2">
                  <v-dialog v-model="dialog" :retain-focus="false">
                    <template v-slot:activator="{}">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color=""
                            x-small
                            icon
                            @click.stop="dialog = true"
                            v-bind="attrs"
                            v-on="on"
                            class="mt-n1"
                          >
                            <v-icon>mdi-help-circle</v-icon>
                          </v-btn>
                        </template>
                        <span
                          >Click here to get the extension of tumor
                          abbreviations.</span
                        >
                      </v-tooltip>
                    </template>
                    <v-card style="left: 25%; width: 50%">
                      <v-card-title
                        class="font-weight-bold grey lighten-2"
                        style="padding: 0px 0px 0px 20px"
                      >
                        TCGA Project ID - Project Name
                        <v-spacer></v-spacer>
                        <v-btn icon large @click="dialog = false">
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-simple-table dense fixed-header height="600px">
                        <template v-slot:default>
                          <thead class="font-weight-bold">
                            <tr>
                              <th class="text-left" style="width: 30%">
                                Project ID
                              </th>
                              <th class="text-left" style="width: 70%">
                                Project Name
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>TCGA-ACC</td>
                              <td>Adrenocortical Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-BLCA</td>
                              <td>Bladder Urothelial Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-BRCA</td>
                              <td>Breast Invasive Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-CESC</td>
                              <td>
                                Cervical Squamous Cell Carcinoma and
                                Endocervical Adenocarcinoma
                              </td>
                            </tr>
                            <tr>
                              <td>TCGA-CHOL</td>
                              <td>Cholangiocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-COAD</td>
                              <td>Colon Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-DLBC</td>
                              <td>
                                Lymphoid Neoplasm Diffuse Large B-cell Lymphoma
                              </td>
                            </tr>
                            <tr>
                              <td>TCGA-ESCA</td>
                              <td>Esophageal Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-GBM</td>
                              <td>Glioblastoma Multiforme</td>
                            </tr>
                            <tr>
                              <td>TCGA-HNSC</td>
                              <td>Head and Neck Squamous Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-KICH</td>
                              <td>Kidney Chromophobe</td>
                            </tr>
                            <tr>
                              <td>TCGA-KIRC</td>
                              <td>Kidney Renal Clear Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-KIRP</td>
                              <td>Kidney Renal Papillary Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LGG</td>
                              <td>Brain Lower Grade Glioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LIHC</td>
                              <td>Liver Hepatocellular Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LUAD</td>
                              <td>Lung Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-LUSC</td>
                              <td>Lung Squamous Cell Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-MESO</td>
                              <td>Mesothelioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-OV</td>
                              <td>Ovarian Serous Cystadenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PAAD</td>
                              <td>Pancreatic Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PCPG</td>
                              <td>Pheochromocytoma and Paraganglioma</td>
                            </tr>
                            <tr>
                              <td>TCGA-PRAD</td>
                              <td>Prostate Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-READ</td>
                              <td>Rectum Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-SARC</td>
                              <td>Sarcoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-SKCM</td>
                              <td>Skin Cutaneous Melanoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-STAD</td>
                              <td>Stomach Adenocarcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-TGCT</td>
                              <td>Testicular Germ Cell Tumors</td>
                            </tr>
                            <tr>
                              <td>TCGA-THCA</td>
                              <td>Thyroid Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-THYM</td>
                              <td>Thymoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UCEC</td>
                              <td>Uterine Corpus Endometrial Carcinoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UCS</td>
                              <td>Uterine Carcinosarcoma</td>
                            </tr>
                            <tr>
                              <td>TCGA-UVM</td>
                              <td>Uveal Melanoma</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </v-dialog>
                </span>
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="!isoform_percent_no_data">
              <d3-chart :options="isoformPercentChartOptions"></d3-chart>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-else class="mt-1">
              <span>{{ isoform_percent_no_data }}</span>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="as-model">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">
                Alternative Splicing Models of {{ $route.query.genename }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                dense
                class="data-table-style"
                :headers="headers_as_model"
                :items="as_model_items"
                fixed-header
                v-model="selected_row"
                :loading="loading_as_model"
                loading-text="Loading... Please wait"
                no-data-text="There is no AS Models."
                hide-default-footer
                :page.sync="currentPage_as_model"
                :items-per-page="pageSize_as_model"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.index }}</td>
                    <td>{{ item.as_type }}</td>
                    <td>{{ item.as_model_id }}</td>
                    <td>
                      <v-btn
                        @click="
                          goToVisualiztion(
                            item.gene_name,
                            item.as_type,
                            item.event_coordinates
                          )
                        "
                        color="info"
                        icon
                      >
                        <v-icon>mdi-tune</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <span v-for="(flag, index) in item.flag" :key="index">
                        <v-chip
                          outlined
                          small
                          :color="flag == 'CASE' ? 'info' : 'success'"
                        >
                          {{ flag }}
                        </v-chip>
                      </span>
                    </td>
                  </tr>
                </template>

                <!-- header.flag slot -->
                <template v-slot:[`header.flag`]="{ header }">
                  {{ header.text }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on"
                        >mdi-help-circle</v-icon
                      >
                    </template>
                    <span
                      ><span class="font-weight-bold info--text">CASE</span>:
                      Cancer Associated Splicing Events<br />
                      <span class="font-weight-bold success--text">CPSE</span>:
                      Computationally Putative Splicing Events</span
                    >
                  </v-tooltip>
                </template>
              </v-data-table>
              <div class="d-flex justify-center mt-1" style="max-height: 50px">
                <span class="text-body-1 mt-3">Items per page</span>
                <v-select
                  v-model="pageSize_as_model"
                  dense
                  outlined
                  :items="pageSizes_as_model"
                  class="pagesize-select mt-1 mx-2"
                  @input="handlePageSizeChange_as_model(pageSize_as_model)"
                >
                </v-select>
                <span class="text-body-1 mt-3 mx-2"
                  >Total
                  <span class="font-weight-bold info--text">{{
                    totalItems_as_model
                  }}</span>
                  items
                </span>
                <v-pagination
                  v-model="currentPage_as_model"
                  color="info"
                  :length="totalPages_as_model"
                  :total-visible="5"
                  class="mx-1"
                  @input="handlePageChange_as_model"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
                <span class="text-body-1 mt-2 mx-2">Page</span>
                <v-text-field
                  outlined
                  dense
                  v-model="whichPage_as_model"
                  type="number"
                  class="jump-select"
                  append-icon=""
                >
                </v-text-field>
                <v-btn
                  color=""
                  depressed
                  outlined
                  class="mx-2"
                  @click="jumpPage_as_model()"
                  >Jump</v-btn
                >
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="exp-confirm">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">
                Cancer Associated Splicing Events (CASE) of
                {{ $route.query.genename }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <knowledge-result-by-gene
                :gene-name="geneName"
              ></knowledge-result-by-gene>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel id="software-predict">
            <v-expansion-panel-header class="font-weight-bold">
              <span class="text-decoration-underline">
                Computationally Putative Splicing Events (CPSE) of
                {{ $route.query.genename }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <datasets-result-by-gene
                :gene-name="geneName"
              ></datasets-result-by-gene>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="3" sm="3" md="3" lg="3" class="side_bar">
        <v-list dense outlined rounded>
          <v-list-item>
            <v-list-item-title class="d-flex justify-center font-weight-bold">
              <span style="font-size: 1rem !important">Table of Contents</span>
            </v-list-item-title>
          </v-list-item>
          <!-- <v-divider></v-divider> -->
          <div class="d-flex justify-center font-weight-bold">
            <v-chip
              outlined
              small
              color="success"
              class="mx-2"
              @click="showAll()"
            >
              Show All
            </v-chip>
            <v-chip
              outlined
              small
              color="error"
              class="mx-2"
              @click="showNone()"
            >
              Collapse All
            </v-chip>
          </div>
          <v-divider class="my-2"></v-divider>

          <v-list-item-group v-model="panels" multiple color="info">
            <v-list-item
              v-for="(item, index) in itemsList"
              :key="index"
              @click="goToAnchor(item.url, index)"
            >
              <v-list-item-title>
                {{ index + 1 }}. {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>

    <!-- back to top -->
    <back-to-top></back-to-top>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import {
  getGeneInfoByGenename,
  getGencodeGenePatternByGenename,
} from "node/details";
import { getIsoformPercentByGenename } from "node/general";
import {
  getASModelsByGenenamFromKnowledge,
  getASModelsByGenenameFromDatasets,
} from "node/browse";
import KnowledgeResultByGene from "./KnowledgeResultByGene.vue";
import DatasetsResultByGene from "./DatasetsResultByGene.vue";
import GeneTranscriptStructure from "./GeneTranscriptStructure";
import GenePancancerExp from "views/visualization/GenePancancerExp";
import BackToTop from "@/components/main/BackToTop";

export default {
  name: "GeneSearchResult",
  components: {
    KnowledgeResultByGene,
    DatasetsResultByGene,
    GeneTranscriptStructure,
    GenePancancerExp,
    BackToTop,
  },
  data() {
    return {
      breadItems: [
        {
          text: "Home",
          disabled: false,
          href: "/ascancer/home",
        },
        {
          text: "Gene",
          disabled: true,
        },
      ],

      geneName: null,
      panels: [0, 1, 2, 3, 4, 5, 6, 7],
      // panels: [0, 1, 2, 3, 4, 5, 6, 7],

      itemsList: [
        { title: "Basic Information", url: "#basic" },
        { title: "Gene Expression in Pan-Cancer", url: "#gene-exp" },
        { title: "Transcript Information", url: "#tx-info" },
        { title: "Transcript Structure", url: "#tx-struct" },
        { title: "Isoform Percentage in Pan-Cancer", url: "#iso-pct" },
        { title: "AS Models", url: "#as-model" },
        {
          title: "Cancer Associated Splicing Events (CASE)",
          url: "#exp-confirm",
        },
        {
          title: "Computationally Putative Splicing Events (CPSE)",
          url: "#software-predict",
        },
      ],
      // selectedItem: 1,

      geneInfo: [],
      gencodeGenePattern: [],
      hgncLink:
        "https://www.genenames.org/data/gene-symbol-report/#!/hgnc_id/HGNC:",
      ncbiGeneLink: "https://www.ncbi.nlm.nih.gov/gene/",
      refseqLink: "https://www.ncbi.nlm.nih.gov/nuccore/",
      ensemblLink:
        "https://grch37.ensembl.org/Homo_sapiens/Gene/Summary?db=core;g=",
      uniprotLink: "https://www.uniprot.org/uniprot/",
      ucscLink: "",
      omimLink: "https://omim.org/entry/",

      expression_tpm_median: [],
      cancers: [],
      tumors: [],
      normals: [],

      isShowExpBoxPlot: true,
      gene_pancancer_no_data: null,

      isoform_percent: [],
      isoform_percent_no_data: null,
      isoformPercentChartOptions: {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: [],
          labels: {
            step: 1,
            rotation: -45,
            // staggerLines: 1,
            style: {
              "font-family": '"Roboto", sans-serif',
              "font-size": 10,
              "font-weight": "",
            },
          },
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Isoform Percentage",
            style: {
              "font-family": '"Roboto", sans-serif',
              "font-size": 12,
              "font-weight": "",
            },
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>:' +
            "({point.percentage:.2f}%)<br/>",
          //:.2f 表示保留 2 位小数
          shared: true,
          style: {
            "font-family": "Arial",
            "font-size": 12,
            "font-weight": "bold",
          },
        },
        plotOptions: {
          column: {
            stacking: "percent",
            pointPadding: 0.15,
            groupPadding: 0.1,
            borderWidth: 0,
          },
        },
        series: [],
      },

      // All AS Models of single gene
      headers_as_model: [
        { text: "Index", value: "", align: "start", sortable: false },
        { text: "AS Type", value: "as_type", align: "start", sortable: true },
        {
          text: "AS Model ID",
          value: "as_model_id",
          align: "start",
          sortable: false,
        },
        { text: "Visualization", value: "", align: "start", sortable: false },
        { text: "Flags", value: "flag", align: "start", sortable: false },
      ],
      as_model_items: [],
      selected_row: [],
      loading_as_model: true,
      currentPage_as_model: 1,
      whichPage_as_model: 1,
      pageSize_as_model: 5,
      totalPages_as_model: 0,
      pageSizes_as_model: [5, 10, 15, 20, 50, 100],
      totalItems_as_model: 0,

      gene_start: null,
      gene_end: null,
      strand: null,
      transcript: [],
      all_tx_exon: [],
      all_tx_intron: [],
      all_tx_utr: [],
      all_start_codon: [],
      all_stop_codon: [],

      dialog: false,
    };
  },
  created() {
    if (this.$route.query.genename) {
      this.getGeneInfoByGenename();
      this.getIsoformPercentByGenename();
      this.getGencodeGenePatternByGenename();

      this.getAllASModelsByGenename();
    }
  },
  mounted() {
    // 必须放在这里，不然不能传给子组件
    this.geneName = this.$route.query.genename;

    this.breadItems.push({
      text: this.geneName,
      disabled: true,
    });

    // 侧边栏滑动效果
    // 获取每个大div的offsetTop
    // this.list = [];
    // this.contentList.forEach((item, ind) => {
    //   let obj = {
    //     offsetTop: document.querySelector(`#content${ind}`).offsetTop
    //   };
    //   this.list.push(obj);
    // });
    // // 监听滚动事件
    // window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    as_model_items(val) {
      if (val) {
        this.loading_as_model = false;
      }
    },
  },
  methods: {
    getGeneInfoByGenename() {
      let genename;
      if (this.$route.query.genename) {
        genename = this.$route.query.genename;
      }
      // console.log(genename);
      genename &&
        getGeneInfoByGenename(genename)
          .then((result) => {
            // console.log(result);
            this.geneInfo = result;
          })
          .catch((err) => {
            console.error(err);
          });
    },
    async getIsoformPercentByGenename() {
      let genename;
      if (this.$route.query.genename) {
        genename = this.$route.query.genename;
      }
      if (genename) {
        await getIsoformPercentByGenename(genename)
          .then((result) => {
            // console.log(result);
            if (result && result.length > 0) {
              let categories = [];
              // Object.keys(result[0]).forEach((b, c, d) => {
              //   b.includes("-") && categories.push(b.split('-')[0])
              // })
              Object.keys(result[0]).forEach((b, c, d) => {
                if (b.includes("-")) {
                  categories.push(b);
                }
                if (b.includes("null")) {
                  categories.push("");
                }
              });
              // categories = [...new Set(categories)]
              // console.log(categories);

              let iso_pct = [];
              result.forEach((v, i, a) => {
                let tx = {};
                tx.name = v.ensembl_transcript_id;
                tx.data = [];
                Object.keys(v).forEach((b, c, d) => {
                  if (b.includes("-")) {
                    tx.data.push(v[b]);
                  }
                  if (b.includes("null")) {
                    tx.data.push(v[b]);
                  }
                });
                iso_pct.push(tx);
              });
              // console.log(iso_pct);

              // console.log(categories);
              this.isoformPercentChartOptions.xAxis.categories = categories;
              this.isoform_percent = iso_pct;
              this.isoform_percent_no_data = null;
              this.isoformPercentChartOptions.series = iso_pct;
            } else {
              this.isoform_percent_no_data =
                "Sorry, there is no isoform percentage information for this Gene.";
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    async getGencodeGenePatternByGenename() {
      let genename;
      if (this.$route.query.genename) {
        genename = this.$route.query.genename;
      }
      if (genename) {
        await getGencodeGenePatternByGenename(genename)
          .then((result) => {
            if (result) {
              this.gene_start = result[0].start;
              // console.log(this.gene_start);
              this.gene_end = result[0].end;
              // console.log(this.gene_end);
              this.strand = result[0].strand;
              // console.log(this.strand);
              let transcript = result[0]["transcript"];

              let all_transcript = [];
              Object.keys(transcript)
                .sort()
                .map((d) => all_transcript.push(transcript[d]));
              // console.log(all_transcript);
              result[0]["transcript"] = all_transcript; // replaced as sorted transcript
              this.gencodeGenePattern = result;

              this.transcript = all_transcript;
              // console.log(this.transcript)

              // get all exons coordinate
              let all_tx_exon = [];
              // get all utr coordinate
              let all_tx_utr = [];
              // get all start_codon coordinate
              let all_start_codon = [];
              // get all stop_codon coordinate
              let all_stop_codon = [];
              all_transcript &&
                all_transcript.forEach((value, index, array) => {
                  value.exons.forEach((v, i, a) => {
                    let tx_exon = {};
                    tx_exon["exon_number"] = v.exon_number;
                    tx_exon["exon_id"] = v.exon_id;
                    tx_exon["chr"] = v.chr;
                    tx_exon["start"] = v.start;
                    tx_exon["end"] = v.end;
                    tx_exon["length"] = v.length;
                    tx_exon["strand"] = v.strand;
                    tx_exon["tx"] = value.transcript_name;
                    all_tx_exon.push(tx_exon); // 注意：此处不能写 this.all_tx_exon.push(tx_exon) ,否则 all_tx_exon 会进行不断叠加
                  });

                  value.utr.forEach((v, i, a) => {
                    let tx_utr = {};
                    tx_utr["chr"] = v.chr;
                    tx_utr["start"] = v.start;
                    tx_utr["end"] = v.end;
                    tx_utr["length"] = v.length;
                    tx_utr["strand"] = v.strand;
                    tx_utr["tx"] = value.transcript_name;
                    all_tx_utr.push(tx_utr);
                  });

                  value.start_codon.forEach((v, i, a) => {
                    let start_codon = {};
                    start_codon["chr"] = v.chr;
                    start_codon["start"] = v.start;
                    start_codon["end"] = v.end;
                    start_codon["length"] = v.length;
                    start_codon["strand"] = v.strand;
                    start_codon["tx"] = value.transcript_name;
                    all_start_codon.push(start_codon);
                  });

                  value.stop_codon.forEach((v, i, a) => {
                    let stop_codon = {};
                    stop_codon["chr"] = v.chr;
                    stop_codon["start"] = v.start;
                    stop_codon["end"] = v.end;
                    stop_codon["length"] = v.length;
                    stop_codon["strand"] = v.strand;
                    stop_codon["tx"] = value.transcript_name;
                    all_stop_codon.push(stop_codon);
                  });
                });
              this.all_tx_exon = all_tx_exon;
              // console.log(this.all_tx_exon);
              this.all_tx_utr = all_tx_utr;
              // console.log(this.all_tx_utr);
              this.all_start_codon = all_start_codon;
              // console.log(this.all_start_codon);
              this.all_stop_codon = all_stop_codon;
              // console.log(this.all_stop_codon);

              // get all introns coordinate
              let all_tx_intron = [];
              all_transcript &&
                all_transcript.forEach((value, index, array) => {
                  value.exons.forEach((v, i, a) => {
                    if (i < value.exons.length - 1 && v.strand == "+") {
                      let tx_intron = {};
                      tx_intron["start"] = v.end;
                      tx_intron["end"] = a[i + 1].start;
                      tx_intron["tx"] = value.transcript_name;
                      all_tx_intron.push(tx_intron);
                    }

                    if (i < value.exons.length - 1 && v.strand == "-") {
                      let tx_intron = {};
                      tx_intron["end"] = v.start;
                      tx_intron["start"] = a[i + 1].end;
                      tx_intron["tx"] = value.transcript_name;
                      all_tx_intron.push(tx_intron);
                    }
                  });
                });
              this.all_tx_intron = all_tx_intron;
              // console.log(this.all_tx_intron);
            }
          })
          .catch((err) => {
            console.error("There is no gencode gene pattern of", genename);
          });
      }
    },
    async getAllASModelsByGenename() {
      let genename;
      if (this.$route.query.genename) {
        genename = this.$route.query.genename;
      }
      // console.log(genename);
      let promise1 = new Promise((resolve, reject) => {
        getASModelsByGenenamFromKnowledge(genename)
          .then((result) => {
            // console.log(result);
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });

      let promise2 = new Promise((resolve, reject) => {
        getASModelsByGenenameFromDatasets(genename)
          .then((result) => {
            // console.log(result);
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([promise1, promise2])
        .then((result) => {
          // console.log(result);
          let as_model_items = [];
          let as_models = [];
          result[0] &&
            result[0].forEach((v, i, a) => {
              if (as_models.indexOf(v.as_model_id) === -1) {
                as_models.push(v.as_model_id);
                v.flag = ["CASE"];
                as_model_items.push(v);
              }
            });
          // console.log(as_model_items);

          let as_model_items1 = [];
          let as_models1 = [];
          result[1] &&
            result[1].forEach((v, i, a) => {
              if (as_models1.indexOf(v.as_model_id) === -1) {
                as_models1.push(v.as_model_id);
                v.flag = ["CPSE"];
                as_model_items1.push(v);
              }
            });
          // console.log(as_model_items1);

          if (as_model_items.length > 0) {
            as_model_items1.forEach((v, i, a) => {
              let index = as_models.indexOf(v.as_model_id);
              // can't find
              if (index === -1) {
                as_model_items.push(v);
              } else {
                // can find
                // console.log(index);
                if (as_model_items[index]["flag"].indexOf("CPSE") === -1) {
                  as_model_items[index]["flag"].push("CPSE");
                }
              }
            });
            as_model_items.forEach((v, i, a) => {
              v.index = i + 1;
            });
            this.as_model_items = as_model_items;
            this.totalItems_as_model = as_model_items.length;
            this.totalPages_as_model = Math.ceil(
              as_model_items.length / this.pageSize_as_model
            );
          } else {
            as_model_items1.forEach((v, i, a) => {
              v.index = i + 1;
            });
            this.as_model_items = as_model_items1;
            this.totalItems_as_model = as_model_items1.length;
            this.totalPages_as_model = Math.ceil(
              as_model_items1.length / this.pageSize_as_model
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlePageChange_as_model(value) {
      this.currentPage_as_model = value;
      this.whichPage_as_model = this.currentPage_as_model;
    },
    handlePageSizeChange_as_model(size) {
      this.pageSize_as_model = size;
      this.currentPage_as_model = 1;
      this.totalPages_as_model = Math.ceil(
        this.as_model_items.length / this.pageSize_as_model
      );
    },
    jumpPage_as_model() {
      // console.log(+this.whichPage);
      if (+this.whichPage_as_model < 1) {
        this.whichPage_as_model = 1;
      }
      if (+this.whichPage_as_model > this.totalPages_as_model) {
        this.whichPage_as_model = this.totalPages_as_model;
      }
      this.currentPage_as_model = +this.whichPage_as_model;
    },
    computeHeight(obj) {
      if (Object.keys(obj).length > 7) {
        return 250;
      } else {
        return null;
      }
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router
        .push({
          path: "/splicevis",
          query: {
            genename: genename,
            astype: astype,
            coordinate: coordinate,
          },
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            logError(err);
          }
        });
    },
    goToAnchor(selector, index) {
      // console.log(this.panels);
      if (!this.panels.includes(index)) {
        // this.panels.push(index);
        this.panels = [...this.panels, index];
        // this.$set(this.panels, this.panels.length, index);
        // console.log(this.panels);
      } else {
        let i = this.panels.indexOf(index);
        // this.panels.splice(i, 1);
        let panels = [...this.panels]; // 这里必须先替换成非响应式
        // console.log(panels);
        this.panels = panels.splice(i, 1);
      }
      // console.log(index);

      // block: Defines vertical alignment.
      // inline: Defines horizontal alignment.
      // this.$el.querySelector(selector)
      //   .scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

      const scrollToAnimationFn = (number = 0, time) => {
        if (!time) {
          document.body.scrollTop = document.documentElement.scrollTop = number;
          return number;
        }
        const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
        let spacingInex = time / spacingTime; // 计算循环的次数
        let nowTop =
          document.body.scrollTop || document.documentElement.scrollTop; // 获取当前滚动条位置
        const everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
        const scrollTimer = setInterval(() => {
          if (spacingInex > 0) {
            spacingInex--;
            scrollToAnimationFn((nowTop += everTop));
          } else {
            clearInterval(scrollTimer); // 清除计时器
          }
        }, spacingTime);
      };

      let ele = this.$el.querySelector(selector);
      if (ele) {
        scrollToAnimationFn(ele.offsetTop + 80, 500);
      }
    },
    showAll() {
      this.panels = [0, 1, 2, 3, 4, 5, 6, 7];
    },
    showNone() {
      this.panels = [];
    },
    isShowExpPancanBoxplot(data) {
      // console.log(data);
      this.isShowExpBoxPlot = data;
      if (data == true) {
        this.gene_pancancer_no_data = null;
      } else {
        this.gene_pancancer_no_data =
          "Sorry, there is no expression information for this Gene.";
      }
    },
  },
};
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-card__title
  line-height: 0.5rem

.v-expansion-panel--active > .v-expansion-panel-header
  min-height: 45px

.v-list-item__title
  font-size: 0.875rem !important

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.pagesize-select
  max-width: 8%

.jump-select
  max-width: 8%

.side_bar
  position: fixed
  right: 1%
  top: 415px
  transform: translateY(-50%)
</style>
